__turbopack_context__.v({
  "Container": "SkeletonPulse-module__DToOra__Container" + " " + "cds-t-body",
  "PulseLine": "SkeletonPulse-module__DToOra__PulseLine",
  "SkeletonPulse": "SkeletonPulse-module__DToOra__SkeletonPulse",
  "pulse": "SkeletonPulse-module__DToOra__pulse",
});
